import React from "react";
import LoadingIcon from "../icons/LoadingIcon";
import clsx from "clsx";

const PrimaryLinkButton = ({
  disabled,
  loading,
  type = "submit",
  children,
  startIcon,
  ...others
}) => {
  return (
    <button
      disabled={disabled || loading}
      type={type}
      className={clsx(
        "text-primary hover:text-primaryHover text-base font-semibold leading-6",
        {
          "cursor-progress": loading,
          "cursor-not-allowed !text-primaryDisabledText !outline-primaryDisabledBorder":
            disabled,
        }
      )}
      {...others}
    >
      <div className="flex items-center gap-2">
        {loading ? <LoadingIcon /> : startIcon}
        <span>{children}</span>
      </div>
    </button>
  );
};

export default PrimaryLinkButton;
